import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Add Employment Information")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-2 mt-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-6" }, "Certified Trainees", -1)
const _hoisted_24 = { class: "card mb-5 mb-xl-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_26 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_27 = { class: "collapse show" }
const _hoisted_28 = { class: "card-body border-top p-6" }
const _hoisted_29 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-plus-circle" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-minus-circle" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddJobDrawer = _resolveComponent("AddJobDrawer")!
  const _component_EditJobDrawer = _resolveComponent("EditJobDrawer")!
  const _component_ReleaseJobDrawer = _resolveComponent("ReleaseJobDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    name: "tranche_id",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.changeTranche
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    name: "entity_id",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.getTrainingInstitute
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString("[" + info.entity_short_name + "] - " + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    name: "institute_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.courseInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                    name: "course_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Batch",
                    modelValue: _ctx.batch.batch_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                    name: "batch_id",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.batch_sequence_number,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getTraineeList())),
                    type: "button",
                    class: "btn btn-success p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_22
                  ])
                ])
              ]),
              (_ctx.showDataTable)
                ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_Datatable, {
                                "table-data": _ctx.traineeList,
                                "table-header": _ctx.tableHeader,
                                "enable-items-per-page-dropdown": true
                              }, {
                                "cell-id": _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(row.id), 1)
                                ]),
                                "cell-image": _withCtx(({ row: industry }) => [
                                  _createElementVNode("img", {
                                    src: 
                                    _ctx.api_url + industry?.attach_file_info?.file_path
                                  ,
                                    alt: "",
                                    width: "32",
                                    height: "32"
                                  }, null, 8, _hoisted_30)
                                ]),
                                "cell-ref_no": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.reference_number), 1)
                                ]),
                                "cell-reg_no": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.registration_number), 1)
                                ]),
                                "cell-name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.trainee_name), 1)
                                ]),
                                "cell-father_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.father_name), 1)
                                ]),
                                "cell-mother_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.mother_name), 1)
                                ]),
                                "cell-nid": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.nid), 1)
                                ]),
                                "cell-phone": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.mobile), 1)
                                ]),
                                "cell-employment_status": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.current_trainee_employment
                                  ?.employment_status
                                  ? "Yes"
                                  : "No"), 1)
                                ]),
                                "cell-actions": _withCtx(({ row: industry }) => [
                                  (
                                  industry?.current_trainee_employment
                                    ?.employment_status
                                )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.edit(industry.current_trainee_employment)),
                                        title: "Edit Job Placement",
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_edit_job",
                                        id: "kt_drawer_edit_job_button",
                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_33, 8, _hoisted_31))
                                    : _createCommentVNode("", true),
                                  (
                                  !industry?.current_trainee_employment
                                    ?.employment_status
                                )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_add_job",
                                        onClick: ($event: any) => (_ctx.Add(industry)),
                                        id: "kt_drawer_add_job_button",
                                        title: "ADD",
                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_36, 8, _hoisted_34))
                                    : _createCommentVNode("", true),
                                  (
                                  industry?.current_trainee_employment
                                    ?.employment_status
                                )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_release_job",
                                        id: "kt_drawer_release_job_button",
                                        onClick: ($event: any) => (_ctx.Release(industry.current_trainee_employment.id)),
                                        title: "Release Job",
                                        class: "btn btn-icon btn-bg-warning btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_39, 8, _hoisted_37))
                                    : _createCommentVNode("", true),
                                  (
                                  industry?.current_trainee_employment
                                    ?.employment_status
                                )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 3,
                                        onClick: ($event: any) => (_ctx.Delete(industry.current_trainee_employment.id)),
                                        class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                      }, _hoisted_42, 8, _hoisted_40))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["table-data", "table-header"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_AddJobDrawer),
    _createVNode(_component_EditJobDrawer),
    _createVNode(_component_ReleaseJobDrawer)
  ], 64))
}